export const TRANSACTIONS_COLUMNS = [
    { name: 'Transaction ID', key: 'transactionId', dbName: 'Transaction ID' },
    { name: 'Status', key: 'status', dbName: 'Status' },
    { name: 'POS Value', key: 'amountPOS', secondKey: 'posDateTime', dbName: 'Amount (POS)' },
    { name: 'POS Date', key: 'posDateTime', dbName: 'Date (POS)' },
    { name: 'PSP Value', key: 'amountPSP', secondKey: 'pspDateTime', dbName: 'Amount(PSP)' },
    { name: 'PSP Date', key: 'pspDateTime', dbName: 'Date (PSP)' },
    { name: 'Type', key: 'type', dbName: 'Transaction Type' },
    // { name: 'Date & time', key: 'dateTime', dbName: 'Date & time(POS)' },
    { name: 'Variance', key: 'variance', dbName: 'Variance' },
    { name: 'Department', key: 'department', dbName: 'Department' },
    // { name: 'Date & time (POS)', key: '' },
    { name: 'Reason', key: 'reason', dbName: 'Reason' },
	{ name: 'Matching Reference', key: 'matchingReference', dbName: 'Reference' },
    // { name: 'RAG score', key: 'rag', dbName: 'RAG score' },
    // { name: 'Date Analyzed', key: 'dateAnalyzed', dbName: 'Date Analyzed' },
    // { name: 'File Name', key: 'fileName', dbName: 'File Name' },
    // { name: 'Description', key: 'description', dbName: 'Description' },
    { name: 'Card', key: 'last4digits', dbName: 'card' },
]